const formTemplate = {
  'areaCode': 'string 报名区域Code',
  'areaName': 'string 报名区域名称',
  'containArea': 'integer 原就读学校是否在区内: 0=区内、1=区外',
  'guardian': {
		'address': '详细居住详细地址',
    'accordType': 'integer 积分信息是否符合: 0=符合、1=不符合',
    'areaCode': 'string (委托)监护人户籍所属区/县CODE',
    'areaName': 'string (委托)监护人户籍所属区/县名称',
    'certificateType': 'integer 证件类型: 0=其它、1=四川省居住证/成都市居住证、2=成都市（除龙泉驿区外）户籍居民身份证',
    'cityCode': 'string (委托)监护人户籍所属州/市/区CODE',
    'cityName': 'string (委托)监护人户籍所属州/市/区名称',
    'companyCode': 'string 工作单位信用代码(中小学必填)',
    'companyName': 'string 工作单位名称',
    'communityName': 'string 小区名字',
    'countryName': 'string 国籍(幼儿园委托监护人不需要)名称',
    'education': 'string 学历',
    'guardianType': 'integer 监护人类型：1=法定监护人、2=委托监护人、3=普通监护人(中小学)',
    'houseNumber': 'string (委托)监护人户籍号',
    'idCard': 'string 身份证号码',
    'jobType': 'integer 稳定就业材料: 0=其它、1=劳动合同、2=办理有工商营业执照',
    'mobile': 'string 手机号码',
    'name': 'string (委托)监护人姓名',
    'nationName': 'string 民族名称',
    'proofType': 'integer 居住满一年材料类型：1=自购房者(提供房产证明或购房合同)、2=居住直系亲属自购房者(提供房产证明和亲属关系证明)、3=居住房屋者(提供《房屋租赁登记备案凭证》)、4=租住公租房和廉租房者(提供租赁合同)、5=居住单位或集体宿舍者(提供该单位集体宿舍的房产证明及单位出具的实际居住证明)',
    'provinceCode': 'string (委托)监护人户籍所属省份CODE',
    'provinceName': 'string (委托)监护人户籍所属省份名称',
    'relationType': 'integer 关系证明类型: 1=申请人及其子女同一户籍的原籍户口簿、2=子女父母双方的户口簿/结婚证/孩子出生医学证明或亲子鉴定、3=申请人的户口簿/被监护人的户口簿/司法部门出具其法定监护关系的证明',
    'relationship': 'string 委托人与幼儿的关系',
    'residenceType': 'integer 居住证类型：1=四川省居住证、2=成都市居住证',
    'sex': 'integer 性别',
    'socialSecurityProve': 'integer 是否有社保证明：0=无、1=有',
    'streetId': 'string 所属街道ID',
    'villageCode': 'string (委托)监护人户籍所属社区CODE',
    'villageName': 'string (委托)监护人户籍所属社区名称'
  },
  'hasStudentStatus': 'integer 是否有原就读学校签章的学籍信息：0=无、1=有',
  'oldSchoolName': 'string 原就读学校名称',
  'orderGradeName': 'string 申请就读年级ID',
  'orderSchoolId': 'string 预约学校ID',
  'orderSchoolName': 'string 预约学校名称',
  'orderStreetCode': 'string 预约街道CODE',
  'orderStreetName': 'string 预约街道名称',
  'signupNoticeId': 'string 报名通知ID',
  'signupQuotaId': 'string 报名名额ID',
  'student': {
    'address': 'string 居住地址',
    'applyType': 'integer 办理类型: 0=其它、1=材料办理、2=积分办理',
    'areaCode': 'string 所属区/县CODE',
    'areaName': 'string 所属区/县名称',
    'birthday': 'string 出生日期(前端要做校验,后端也会校验,自动识别)',
    'cityCode': 'string 所属州/市/区CODE',
    'cityName': 'string 所属州/市/区名称',
    'homePage': 'string 户口本首页',
    'idCard': 'string 身份证号码',
    'name': 'string 学生姓名',
    'nationName': 'string 民族名称',
    'nativeAreaCode': 'string 户籍所在地区/县CODE',
    'nativeAreaName': 'string 户籍所在地区/县名称',
    'nativeCityCode': 'string 户籍所在地州/市/区CODE',
    'nativeCityName': 'string 户籍所在地州/市/区名称',
    'nativeProvinceCode': 'string 户籍所在地省份CODE',
    'nativeProvinceName': 'string 户籍所在地省份名称',
    'nativeStreetCode': 'string 户籍所在地街道CODE',
    'nativeStreetName': 'string 户籍所在地街道名称',
    'nativeVillageCode': 'string 户籍所在地社区CODE',
    'nativeVillageName': 'string 户籍所在地社区名称',
    'photo': 'string 幼儿照片/学生照片',
    'provinceCode': 'string 所属省份CODE',
    'provinceName': 'string 所属省份名称',
    'sex': 'integer 性别：0=男、1=女',
    'studentPage': 'string 户口本幼儿页'
  },
  'studentSignupId': 'string 预约号(编辑时必传)',
  'studentType': 'integer 报名类型：1=幼儿园报名、2=中小学随迁子女报名'
};

export default {
  data() {
    return {
      form: {}
    };
  },
  created() {
    window.form2 = this.form;
  },
  methods: {
    updateFormData() {
      console.log('[-> PageForm.js] updateFormData');
      // 更新sessionStorage中存的数据到当前form中
      try {
        let data = sessionStorage.getItem('signupMobileForm');
				if (data) data = JSON.parse(data);
				if (!data) {
					this.$router.push({
						path: '/mobile/index'
					});
				}
        console.log('[-> PageForm.js] 从sessionStorage中获取到了form信息', data);
        // 补全字段
        if (!data.student) {
          data.student = {};
        }
        if (!data.guardian) {
          data.guardian = {};
        }
        // 转换字段
        if (data['studentApplyType']) {
          data.student['applyType'] = data['studentApplyType'];
          delete data['studentApplyType'];
        }
        if (data['studentName']) {
          data.student['name'] = data['studentName'];
          delete data['studentName'];
        }
        if (data['idCard']) {
          data.student['idCard'] = data['idCard'];
          delete data['idCard'];
        }
        if (data['guardianMobile']) {
          data.guardian['mobile'] = data['guardianMobile'];
          delete data['guardianMobile'];
        }
        // 转换格式
        if (data.student['idCard']) {
          data.student['birthday'] = this.makeBirthdayByIdCard(data.student['idCard']);
        }
        // 更新
        this.form = data;
      } catch (e) {
        console.error('[-> PageForm.js] updateFormData error', e);
      }
    },
    saveFormData(obj) {
      console.log('[-> PageForm.js] saveFormData', obj);
      // 保存当前数据到sessionStorage中
      try {
        if (typeof obj === 'object') sessionStorage.setItem('signupMobileForm', JSON.stringify(obj));
      } catch (e) {
        console.error('[-> PageForm.js] saveFormData error', e);
      }
    },
    makeBirthdayByIdCard(idCard) {
      return idCard.substring(6, 10) + '-' + idCard.substring(10, 12) + '-' + idCard.substring(12, 14);
    },

    formatFormData(obj) {
      // 格式化从后端获取到的数据，保持跟提交的数据格式完全一致
      for (let key in obj) {
        if (typeof obj[key] === 'object' && formTemplate[key]) {
          for (let sub_key in obj[key]) {
            if (formTemplate[key] && !formTemplate[key][sub_key]) delete obj[key][sub_key];
          }
        } else {
          if (!formTemplate[key]) delete obj[key];
        }
      }
      return obj;
    }
  }
}
